import { render, staticRenderFns } from "./aOrderDetailAddress.vue?vue&type=template&id=638f43c4&scoped=true"
import script from "./aOrderDetailAddress.vue?vue&type=script&lang=js"
export * from "./aOrderDetailAddress.vue?vue&type=script&lang=js"
import style0 from "./aOrderDetailAddress.vue?vue&type=style&index=0&id=638f43c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f43c4",
  null
  
)

export default component.exports